import { createEffect } from '../utils/store';

export const setToken = createEffect('SET_TOKEN');
export const setEnvironmentVariables = createEffect(
  'SET_ENVIRONMENT_VARIABLES',
);
export const clickInteraction = createEffect('USER_CLICK_INTERACTION');
export const toggleAside = createEffect('TOGGLE_ASIDE');
